import { TaggedError } from "@for-it/domain-lib";
export class ApplicantNotFoundError extends TaggedError {
    constructor() {
        super("ApplicantNotFoundError");
    }
}
